/**
 * Endpoints de la bitácora de cambios.
 *
 * El backend lee el historial de Git del proyecto, así que la vista muestra
 * exactamente lo desplegado en el servidor.
 */

import { apiClient } from '@/lib/http/api-client';

import type { Changelog } from './updates.types';

export const updatesKeys = {
  all: ['updates'] as const,
  changelog: (limite: number) => ['updates', limite] as const,
};

export const updatesApi = {
  changelog: (limite: number, signal?: AbortSignal): Promise<Changelog> =>
    apiClient.get<Changelog>(`/api/updates?limit=${limite}`, { signal }),
} as const;
